function CurrencyFormat({ price, currency }) {
  const result = parseFloat(price);
  return `${currency} ${result
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
}

export default CurrencyFormat;
